import React, { useEffect, useMemo, useState } from "react"
import { Card, CardContent, Box, Typography } from "@material-ui/core"
import { MuiThemeProvider } from "@material-ui/core/styles"
import { useSelector, useDispatch } from "react-redux"
import billingTheme from "../../../../themes/billing"
import useStyles from "./styles"
import calculateTotals from "../../../../utils/calculateTotals"
import markUpCalc from "../../../../utils/markUpCalc"

import {
  invoiceColumns,
  mobileInvoiceColumns,
} from "../../../../pages/Shoot/pages/Billing/BillingContext"
import {
  toggleFlaggingDialog,
  toggleClickConfirmationDialog,
} from "../../../../actions/billingDialogs"
import {
  updateExpenseFlagStatus,
  deleteShootRoleCall,
  updateCommissionNet,
  reorderUsersRolesArray,
  updateItemsOrder,
} from "../../../../actions/billing"
import { openSnackBar } from "../../../../actions/snack-bar"

import ExpenseTable, { CommissionNetInput } from "../../Common/ExpenseTable"
import NoteBox from "../../Common/NoteBox/index"
import ExpenseTableTotal from "../../Common/ExpenseTableTotal/index"
import HeaderByLocation from "../../Common/HeaderByLocation/index"
import NoData from "../NoData/index"
import ExportButton from "../ExportButton/index"
import useBillingDisabled from "../../../../hooks/useBillingDisabled"
import usePaidAmountInvoice from "../../../../hooks/usePaidAmountInvoice"
import { values } from "lodash"

const InvoiceCardBilling = props => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [noteVal, setNoteVal] = useState("")

  const shootId = parseInt(props.match.params.shoot_id)
  const generalData = useSelector(state => state.billing.generalData)
  const { discount, invoice_note } = useSelector(
    state => state.billing.generalData
  )

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const mobileScreen = viewportWidth < 600

  const isDisabled = useBillingDisabled()
  const paidAmt = usePaidAmountInvoice()

  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)

  let allExpenses = useMemo(
    () => {
      return [
        ...usersRolesArray.map(role => ({
          ...role,
          expenses: [...role.expenses, ...role.additional_expenses],
        })),
      ]
    },
    [usersRolesArray]
  )
  const amounts = useMemo(
    () => {
      return calculateTotals(allExpenses, paidAmt, discount)
    },
    [allExpenses, paidAmt, discount]
  )

  useEffect(
    () => {
      if (invoice_note !== null) {
        setNoteVal(invoice_note)
      }
    },
    [invoice_note]
  )
  // *** RESOLVE FLAG   ***

  const resolveClientInvoiceFlag = (nextStatusObj, expenseId) => {
    let clientFlagStatus = {
      client_flag_status_id: nextStatusObj.client_flag_status_id,
      client_flag_comment: nextStatusObj.comment,
      additional_expenses: nextStatusObj.additional_expenses,
      shootRole: nextStatusObj.shootRole,
      type: "client",
    }
    dispatch(updateExpenseFlagStatus(clientFlagStatus, expenseId))
      .then(() => {
        dispatch(openSnackBar({ message: "Flag removed successfully" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error resolving this flag" }))
      })
  }

  const openResolveFlagDialog = (nextStatus, item) => {
    let isAdditional = Boolean(item.additional_expense_id)
    let dialogData = {
      flagFunc: resolveClientInvoiceFlag,
      nextStatus: {
        ...nextStatus,
        additional_expenses: isAdditional,
        shootRole: item.shoot_role,
      },
      comment: item.client_flag_comment,
      funcParams: isAdditional
        ? [item.additional_expense_id]
        : [item.expense_id],
    }
    dispatch(toggleFlaggingDialog(true, dialogData))
  }

  // *** RESOLVE FLAG END  ***

  const handleCopyTotal = (role, items) => {
    const total = items => {
      const totalArr = () => {
        return [
          ...items.map(item => {
            let clientRate = item.is_percentage
              ? markUpCalc(item.quantity * item.actual_rate, item.client_rate)
              : item.client_rate
            return Number(
              Number(clientRate) +
                Number(item.actual_rate) * Number(item.quantity) -
                Number(item.discount).toFixed(2)
            )
          }),
        ]
      }
      // if (totalArr().length !== 0)
      try {
        let completeTotal = totalArr()
          .reduce((a, b) => a + b)
          .toFixed(2)
        dispatch(
          openSnackBar({ message: `Amount of $${completeTotal} Copied` })
        )
        return completeTotal
      } catch (err) {
        dispatch(openSnackBar({ message: "Error: No expenses to be totaled" }))
        return "0"
      }
    }

    return total(items)
  }

  // *** DELETE SHOOT ROLE    ***

  const deleteShootRole = (shootRoleId, userId) => {
    dispatch(deleteShootRoleCall(shootRoleId, shootId, userId))
      .then(() => {
        dispatch(openSnackBar({ message: "User/role deleted" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error deleting user/role" }))
      })
  }
  const openConfirmDialog = role => {
    let data = {
      action: "delete this role",
      confirmationFunc: deleteShootRole,
      funcArgs: [role.shoot_role || role.id, role.user_id],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }

  // *** DELETE SHOOT ROLE    ***

  const updateCommissionNetCall = (
    value,
    shootRole,
    setLoading,
    values,
    resetForm,
    setOpen
  ) => {
    let data = { commission_net: Number(value) }
    dispatch(updateCommissionNet(data, shootRole))
      .then(() => {
        dispatch(openSnackBar({ message: "Commission Net updated" }))
        setLoading(false)
        resetForm({ values: values })
        setOpen(false)
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error updating role" }))
        setLoading(false)
        resetForm({ values: values })
        setOpen(false)
      })
  }

  const setItemsOrder = (newItemsArray, roleData) => {
    dispatch(
      reorderUsersRolesArray(
        newItemsArray,
        roleData.role.id || roleData.role.shoot_role
      )
    )

    let orderData = newItemsArray.map((item, index) => ({
      expenseId: item.expense_id ? item.expense_id : item.additional_expense_id,
      expenseType: item.expense_id ? "dmi" : "admi",
      order: index + 1,
    }))

    dispatch(updateItemsOrder(orderData))
  }

  return (
    <MuiThemeProvider theme={billingTheme}>
      {usersRolesArray.length === 0 ? (
        <NoData />
      ) : (
        <Card style={{ padding: "15px" }}>
          <CardContent>
            <Box style={!mobileScreen ? { display: "flex" } : {}}>
              <Box flex={1} position="relative">
                <HeaderByLocation
                  headerInfo={generalData}
                  isDisabled={isDisabled}
                />
                <Box
                  display="flex"
                  justifyContent={viewportWidth > 600 ? "flex-end" : "center"}
                >
                  <ExportButton allExpenses={allExpenses} />
                </Box>
              </Box>
            </Box>
            <ExpenseTable
              columns={!mobileScreen ? invoiceColumns : mobileInvoiceColumns}
              data={allExpenses}
            >
              <ExpenseTable.Header />
              <ExpenseTable.RoleGroup isDisabled={isDisabled}>
                <ExpenseTable.RoleBar>
                  <Box display="flex" flexWrap="wrap">
                    <CommissionNetInput onClick={updateCommissionNetCall} />
                    <ExpenseTable.CopyButton onClick={handleCopyTotal} />
                    <ExpenseTable.DeleteRoleButton
                      onClick={openConfirmDialog}
                    />
                  </Box>
                </ExpenseTable.RoleBar>
                <ExpenseTable.ItemsGroup
                  setItems={setItemsOrder}
                  draggable={true}
                >
                  <ExpenseTable.ItemBar
                    style={!mobileScreen ? { marginLeft: 38 } : {}}
                  >
                    {/* name input */}
                    <ExpenseTable.NameItem
                      style={
                        viewportWidth < 600
                          ? {
                              gridColumn: "1/ span 6",
                            }
                          : {}
                      }
                    />
                    {/* name input ends */}
                    {/* quantity input  */}
                    {!mobileScreen ? (
                      <ExpenseTable.NumberItem valueForProperty="quantity" />
                    ) : (
                      <Box style={{ gridRow: "3/3", gridColumn: "1/3" }}>
                        <Typography className={classes.mobileHeader}>
                          Qty
                        </Typography>
                        <ExpenseTable.NumberItem valueForProperty="quantity" />
                      </Box>
                    )}
                    {/* quantity input ends  */}
                    {/* actual_rate input  */}
                    {!mobileScreen ? (
                      <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                    ) : (
                      <Box style={{ gridRow: "3/3", gridColumn: "3/5" }}>
                        <Typography className={classes.mobileHeader}>
                          Rate($)
                        </Typography>
                        <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                      </Box>
                    )}
                    {/* actual_rate input ends */}
                    {/* client_rate input  */}
                    {!mobileScreen ? (
                      <ExpenseTable.NumberItem
                        valueForProperty="client_rate"
                        style={{ padding: 0 }}
                        InputProps={{
                          classes: {
                            adornedStart: classes.menuButton,
                            input: classes.menuInput,
                          },
                          startAdornment: <ExpenseTable.PercentageButton />,
                        }}
                      />
                    ) : (
                      <Box style={{ gridRow: "3/3", gridColumn: "5/7" }}>
                        <Typography className={classes.mobileHeader}>
                          Markup
                        </Typography>
                        <ExpenseTable.NumberItem
                          valueForProperty="client_rate"
                          InputProps={{
                            classes: {
                              adornedStart: classes.menuButton,
                              input: classes.menuInput,
                            },
                            startAdornment: <ExpenseTable.PercentageButton />,
                          }}
                        />
                      </Box>
                    )}
                    {/* client_rate input ends */}
                    {/* discount input  */}
                    {!mobileScreen ? (
                      <ExpenseTable.NumberItem valueForProperty="discount" />
                    ) : (
                      <Box style={{ gridRow: "4/4", gridColumn: "1/3" }}>
                        <Typography className={classes.mobileHeader}>
                          Discount($)
                        </Typography>
                        <ExpenseTable.NumberItem valueForProperty="discount" />
                      </Box>
                    )}
                    {/* discount input ends */}
                    {/* total input  */}
                    {!mobileScreen ? (
                      <ExpenseTable.TotalItem>
                        {values =>
                          values.is_percentage
                            ? (
                                Number(values.actual_rate) *
                                  Number(values.quantity) +
                                markUpCalc(
                                  values.quantity * values.actual_rate,
                                  values.client_rate
                                ) -
                                Number(values.discount)
                              ).toFixed(2)
                            : (
                                (values.quantity > 0
                                  ? Number(values.client_rate)
                                  : 0) +
                                (Number(values.actual_rate) *
                                  Number(values.quantity) -
                                  Number(values.discount))
                              ).toFixed(2)
                        }
                      </ExpenseTable.TotalItem>
                    ) : (
                      <Box style={{ gridRow: "4/4", gridColumn: "5/7" }}>
                        <Typography className={classes.mobileHeader}>
                          Total($)
                        </Typography>
                        <ExpenseTable.TotalItem>
                          {values =>
                            values.is_percentage
                              ? (
                                  Number(values.actual_rate) *
                                    Number(values.quantity) +
                                  markUpCalc(
                                    values.quantity * values.actual_rate,
                                    values.client_rate
                                  ) -
                                  Number(values.discount)
                                ).toFixed(2)
                              : (
                                  Number(values.client_rate) +
                                  (Number(values.actual_rate) *
                                    Number(values.quantity) -
                                    Number(values.discount))
                                ).toFixed(2)
                          }
                        </ExpenseTable.TotalItem>
                      </Box>
                    )}
                    {/* total input ends */}
                    <ExpenseTable.Item
                      valueForProperty="description"
                      style={
                        !mobileScreen
                          ? {
                              gridColumn: "1/ span 6",
                              gridRow: "2/2",
                            }
                          : {
                              gridRow: "2/3",
                              gridColumn: "1/ span 6",
                            }
                      }
                    />
                    {/* flag input  */}
                    <ExpenseTable.FlagButton
                      hideIfNotFlagged
                      onClick={openResolveFlagDialog}
                    />
                    {/* flag input ends */}
                  </ExpenseTable.ItemBar>
                </ExpenseTable.ItemsGroup>
              </ExpenseTable.RoleGroup>
            </ExpenseTable>
            <Box
              style={
                !mobileScreen
                  ? {
                      marginTop: "40px",
                      display: "flex",
                      justifyContent: "space-between",
                    }
                  : { marginTop: "40px" }
              }
            >
              <Box width={!mobileScreen ? "50%" : "100%"}>
                <NoteBox
                  noteVal={noteVal}
                  setNoteVal={setNoteVal}
                  shootId={shootId}
                  isDisabled={isDisabled}
                  {...props}
                />
              </Box>
              <Box
                width={!mobileScreen ? "50%" : "100%"}
                marginLeft={!mobileScreen ? "20%" : ""}
                marginRight={!mobileScreen ? "20px" : ""}
                flexShrink={1}
              >
                <ExpenseTableTotal
                  data={amounts}
                  addDiscount
                  discount={discount}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}
    </MuiThemeProvider>
  )
}

export default InvoiceCardBilling
